/**
 * The number of times the user has seen the homepage multi user first time landing education banner (either on web or mobile apps) *
 */ export var RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN = 'RETAILER_MULTI_USER_TEAM_EDUCATION_BANNER_SEEN';
